import styled from 'styled-components';

const Footer = styled.footer`
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 800;
  text-align: center;
  padding: 2rem 0rem;
`;

export default Footer;
